
if(['/pages/registreren', '/account/register'].includes(window.location.pathname) || window.location.pathname.includes('/account/register')) {
const intervalTime = 100;
    const maxTime = 8000;
    let elapsedTime = 0;

    const intervalId = setInterval(() => {
        const form = document.querySelector("#country-name");

        if (form) {
            setTimeout(() => {
                handleCustomForm();
            }, 50);

            clearInterval(intervalId);
        }

        elapsedTime += intervalTime;

        if (elapsedTime >= maxTime) {
            clearInterval(intervalId);
        }
    }, intervalTime);
}

function handleCustomForm() {
    var EU_COUNTRIES = [
        "AT", "BE", "BG", "HR", "CY", "CZ", "DK", "EE", "FI", "FR",
        "DE", "GR", "HU", "IE", "IT", "LV", "LT", "LU", "MT", "NL",
        "PL", "PT", "RO", "SK", "SI", "ES", "SE"
    ];

    var euVatField = getField("vat-validation");
    var ukVatField = getField("uk-validation");
    var gstField = getField("gst-validation");
    var abnField = getField("abn-validation");
    hideAllTaxFields();

    document.addEventListener("BSS:rf_change_country", function(e) {

        hideAllTaxFields();
        const countryCode = e.detail.country;
        console.log(countryCode)
        // UK
        if (countryCode === "GB") {
            show(ukVatField);
            return;
        }

        // EU
        if (EU_COUNTRIES.indexOf(countryCode) !== -1) {
            show(euVatField);
            return;
        }

        // India
        if (countryCode === "IN") {
            show(gstField);
            return;
        }

        // Australia
        if (countryCode === "AU") {
            show(abnField);
        }

    });

    function getField(inputId) {
        var input = document.getElementById(inputId);
        return input ? input.closest(".bss-b2b-rf-field") : null;
    }

    function hideAllTaxFields() {
        hide(euVatField);
        hide(ukVatField);
        hide(gstField);
        hide(abnField);
    }

    function hide(field) {
        if (!field) return;
        field.style.display = "none";
        var input = field.querySelector("input");
        if (input) input.value = "";
    }

    function show(field) {
        if (!field) return;
        field.style.display = "block";
    }
}